<div class="editor-field" [formGroup]="dataForm" *ngIf="mode=='EDIT' else showView" [ngClass]="{'basic-mode': basicMode}">
    <div class="row clearfix">
        <div class="col-md-6 col-sm-6 "><label *ngIf="label">{{label}}</label></div>
        <div class="col-md-6 col-sm-6 text-right hidden-xs d-flex justify-content-end align-items-center">
            
            <button type="button" class="btn btn-sm btn-outline-primary dictation-btn mr-1" 
                [class.recording]="isRecording" (click)="toggleDictation()" title="Voice Dictation">
                <i class="pi" [ngClass]="isRecording ? 'pi-spin pi-spinner' : 'pi-microphone'"></i>
            </button>

            <button type="button" class="btn btn-sm transliteration-toggle-btn mr-2" 
                *ngIf="dataForm.value.lang !== 'en'"
                [class.btn-primary]="isTransliterationEnabled" 
                [class.btn-outline-secondary]="!isTransliterationEnabled"
                (click)="toggleTransliteration()" 
                [title]="'Switch to ' + languageLabel">
                <span class="btn-text">{{ languageLabel }}</span>
            </button>

            <div class="btn-group-sm mb-2" role="group" [class.show]="showLangDd">
                <select class="custom-select" formControlName="lang">
                    <ng-container *ngFor="let m of Lang">
                        <option [value]="m?.id">
                            {{m?.name}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>
    </div>
    <ckeditor #editor_box (change)="onChangeDescription()" formControlName="description" [editor]="Editor"
        [config]="editorConfig" name="description" (ready)="onReady($event)">
    </ckeditor>

    <!-- Suggestion Dropdown -->
    <ul class="suggestion-list" *ngIf="showSuggestions" 
        [style.top.px]="suggestionPosition.top" 
        [style.left.px]="suggestionPosition.left">
        <li *ngFor="let s of suggestions; let i = index" 
            [class.active]="i === selectedIndex"
            (click)="selectSuggestion(s)">
            <span class="suggestion-badge">{{ i + 1 }}</span>
            <span class="text">{{ s }}</span>
        </li>
    </ul>
</div>
<ng-template #showView>
    <div class="row clearfix">
        <div class="col-md-6 col-sm-6" *ngIf="label"><label>{{label}}</label></div>
        <p class="col-12" [innerHtml]="description"></p>
    </div>
</ng-template>
<ng-container *ngIf="showPreview">
    <textarea [value]="description" style="width: 100%; height: 40px"></textarea>
    <h3>Form data preview</h3>
    <pre>{{ formDataPreview }}</pre>
</ng-container>